<template>

</template>

<script>
    const isValidHtml = require('is-html');

    export default {
        name: "BackgroundEmbedMixin",
        data () {
            return {

            }
        },
        methods: {
            getEmbed(){
                return this.myData.embedMediaData && this.myData.embedMediaData.value ? this.myData.embedMediaData.value : '';
            },
            setEmbed(embedData){
                this.changeMyData({embedMediaData: embedData});
                this.renderEmbed();
                this.setChangesAreSaved(false);

                const embedWrapper = this.getEmbedWrapper(this.myNode);
                if (embedWrapper && isValidHtml(embedData.value)) {
                    embedWrapper.innerHTML =  embedData.value;
                }
            },
            getEmbedWrapper (node) {
                const wrapper = this.getEmbedWrapperParent(node);

                if (wrapper && wrapper.childNodes) {
                    for(let i = 0; i< wrapper.childNodes.length; i++){
                        if(wrapper.childNodes[i].classList && wrapper.childNodes[i].classList.contains('js-embed-wrapper')){
                            return wrapper.childNodes[i];
                        }
                    }
                }

                return null;
            },
            getEmbedWrapperParent(node){
                if(!node){
                    node = this.myNode;
                }
                return node.querySelector(".js-learnworlds-screen-element .lw-screen-content");
            },
            showEmbed () {
                this.toggleEmbedWrapperDisplay(true);
                this.toggleVideoWrapperDisplay(false);
                this.toggleBgImageDisplay(false);
            },
            renderEmbed(){
                let embedWrapper = this.getEmbedWrapper();

                if (!embedWrapper) {
                    embedWrapper = document.createElement("div");
                    embedWrapper.classList.add("js-embed-wrapper");
                    this.getEmbedWrapperParent().appendChild(embedWrapper);
                }

                this.editEmbedWrapperStyles(embedWrapper);
            },
            editEmbedWrapperStyles(embedWrapper) {
                embedWrapper.classList.add("learnworlds-AR-16-9");
                embedWrapper.classList.add("lw-embed-wrapper");
                embedWrapper.classList.add("learnworlds-element");
                embedWrapper.style.overflow = "hidden";
            },

            toggleEmbedWrapperDisplay(flag){
                let wrapper = this.getEmbedWrapper();

                if (wrapper){
                    wrapper.style.display = (flag)? 'block' : 'none';
                }

                if (flag && !wrapper) {
                    this.renderEmbed();
                }
            },
            removeEmbedWrapper (wrapper) {
                if (!wrapper) {
                    wrapper = this.myNode;
                }

                if (this.getEmbedWrapper(wrapper) ) {
                    this.getEmbedWrapper(wrapper).remove();
                }
            },
            removeEmbedContent (wrapper) {
                if (!wrapper) {
                    wrapper = this.myNode;
                }

                if (this.getEmbedWrapper(wrapper) ) {
                    this.getEmbedWrapper(wrapper).innerHTML =  `{{ '${this.myId}' | embed }}`;
                }
            }
        }
    }
</script>

